import { useEffect } from "react";

/**
 * @description This hook checks for URL parameters related to DFP preview and sets the corresponding targeting in Google Publisher Tags (GPT).
 */
export function useDfpPreview() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dfpPreview = urlParams.get("dfp_preview") || "";
    const testAdId = urlParams.get("test_adid") || "";
    const testPlId = urlParams.get("test_plid") || "";

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(() => {
      if (dfpPreview) {
        googletag.setConfig({ targeting: { dfp_preview: dfpPreview } });
      }
      if (testAdId) {
        googletag.setConfig({ targeting: { test_adid: testAdId } });
      }
      if (testPlId) {
        googletag.setConfig({ targeting: { test_plid: testPlId } });
      }
    });
  }, []);
}
